import { render, staticRenderFns } from "./ApiPortal.vue?vue&type=template&id=467b89ab&scoped=true"
import script from "./ApiPortal.vue?vue&type=script&lang=js"
export * from "./ApiPortal.vue?vue&type=script&lang=js"
import style0 from "./ApiPortal.vue?vue&type=style&index=0&id=467b89ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467b89ab",
  null
  
)

export default component.exports